var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12.0911C0.966667 12.0911 0.652778 11.9603 0.391667 11.6985C0.130556 11.4367 0 11.122 0 10.7544V1.39747C0 1.02987 0.130556 0.715191 0.391667 0.453419C0.652778 0.191647 0.966667 0.0607605 1.33333 0.0607605H10.6667C11.0333 0.0607605 11.3472 0.191647 11.6083 0.453419C11.8694 0.715191 12 1.02987 12 1.39747V10.7544C12 11.122 11.8694 11.4367 11.6083 11.6985C11.3472 11.9603 11.0333 12.0911 10.6667 12.0911H1.33333ZM1.33333 9.3843V10.7544H10.6667V4.90633L6.7 9.41772L4 6.71089L1.33333 9.3843ZM1.33333 7.47949L4 4.80608L6.63333 7.44608L10.6667 2.90127V1.39747H1.33333V7.47949ZM1.33333 4.90633V2.90127V7.44608V4.80608V9.3843V6.71089V9.41772V4.90633ZM1.33333 7.47949V1.39747V7.44608V4.80608V7.47949ZM1.33333 9.3843V6.71089V9.41772V4.90633V10.7544V9.3843Z",
    fill: "#1B51A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line_chart.c7543554ca74cd74f36d3cd794569249.svg";
export { ForwardRef as ReactComponent };